import React, { useState, useEffect, useCallback, useRef } from 'react'
import axios from "axios";
import dayjs from "dayjs";
import 'dayjs/locale/ko';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import HomeIcon from '@material-ui/icons/Home';
import { useStoresWatch } from '../UseStores/UseStore';
import Container from '@material-ui/core/Container';
import { useHistory } from "react-router-dom";
import 'tui-grid/dist/tui-grid.css';
import Grid from '@toast-ui/react-grid';
// import 'tui-pagination/dist/tui-pagination.css';
import '../Shared/Css/Watch.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import WatchTimer from './WatchTimer';
import WatchChart from './WatchChart';
import '../Shared/Css/WatchYebo.css';
import nb01 from '../img/weather/NB01.png' //맑음
import nb01_n from '../img/weather/NB01_N.png' //밤맑음
import nb02_n from '../img/weather/NB02_N.png' //밤구름
import nb03 from '../img/weather/NB03.png' //구름많음
// import nb03_n from '../img/weather/NB03_N.png' //밤구름많음
import nb04 from '../img/weather/NB04.png' //흐림
import nb07 from '../img/weather/NB07.png' //소나기
import nb08 from '../img/weather/NB08.png' //비
import nb11 from '../img/weather/NB11.png' //눈
import nb12 from '../img/weather/NB12.png' //비 또는 눈

function WatchYebo() {
  const gridRef = useRef();
  const [dataApi, setDataApi] = useState([]); // 데이타 저장하기
  const [statedata, setStateData] = useState([]); // 데이타 저장하기
  const [newday, setNewday] = useState(''); //Api불어오는 날짜
  //const [newtime, setNewtime] = useState('0500'); //Api불러오는시간
  const [timerstate, setTimerstate] = useState(true); //Api불러오는시간

  dayjs.locale('ko');

  //히스토리사용
  const history = useHistory();

  //zustend 스테이트 설정
  const { watchTimersub } = useStoresWatch();

  //console.log(`넘긴값:${watchTimersub}`)
  //console.log(`시간Yebo:${Number(dayjs(watchTimersub).format('HH00'))}`)



  const getJsonLoadApi = useCallback(() => {
    const url = "http://apis.data.go.kr/1360000/VilageFcstInfoService_2.0/getVilageFcst"
    axios.get(url, {
      params: {
        serviceKey: "N8bTPeqggrYZOL+7VhNrXw5oPSVjPbUxc8KSr1wAqFqnUTxJSY44ThDbadyxHnDE2ZcLQBHxXfLeFmdX3kZ+Ag==",
        pageNo: 1,
        numOfRows: 1000,
        dataType: "json",
        base_date: `${newday}`,
        //base_time:`${newtime}`,
        base_time: `${watchTimersub}`,
        //base_time:`0500`,
        nx: 89,
        ny: 91
      }
    })
      .then((res) => {
        setDataApi(res.data.response.body.items.item);
      })
      .catch(() => {
        //console.log('axios 통신실패')
      })
  }, [newday, watchTimersub]);

  //초기api 불러오기
  const nowdataApi = (() => {
    setNewday(dayjs(new Date()).format('YYYYMMDD').toString())
    if ((dayjs(new Date()).format('HH') - 1) < 10 && ((dayjs(new Date()).format('HH') - 1).toString()).length === 1) {
      //setNewtime("0" + (dayjs(new Date()).format('HH') - 1).toString() + "00")
    }
    else {
      //setNewtime((dayjs(new Date()).format('HH')-1).toString() + "00")
    }
  })


  useEffect(() => {
    //setNewtime(watchTimersub)
    nowdataApi();
    getJsonLoadApi();
    //console.log('WatchYebo랜드링됨')
  }, [getJsonLoadApi, watchTimersub]);

  const rowss = useCallback(() => {
    var ii = 0;
    let apiwatch = Array([]);
    apiwatch.shift(); //처음 생산된 배열삭제 
    for (var n = 0; n < 4; n++) {
      var datavalue = ((Number(dayjs(new Date()).format('YYYYMMDD')) + n).toString())
      for (var i = 0; i < dataApi.length; i++) {
        if (dataApi[i].category === 'TMP' && dataApi[i].fcstDate === `${datavalue}`) {
          var baseDate = (`${dataApi[i].baseDate}`)  //예측일자
          var baseTime = (`${dataApi[i].baseTime}`)  //예측시간
          var fcstDate = (`${dataApi[i].fcstDate}`)  //예측일자
          var fcstTime = (`${dataApi[i].fcstTime}`)  //예측시간
          var category_tmp = "기온"
          var fcstValue_tmp = (`${dataApi[i].fcstValue}`)
        }
        else if (dataApi[i].category === 'UUU' && dataApi[i].fcstDate === `${datavalue}`) {
        }
        else if (dataApi[i].category === 'VVV' && dataApi[i].fcstDate === `${datavalue}`) {
        }
        else if (dataApi[i].category === 'VEC' && dataApi[i].fcstDate === `${datavalue}`) {
        }
        else if (dataApi[i].category === 'WSD' && dataApi[i].fcstDate === `${datavalue}`) {
        }
        else if (dataApi[i].category === 'SKY' && dataApi[i].fcstDate === `${datavalue}`) {
          var category_sky = "하늘상태"
          var fcstValue_sky
          if (`${dataApi[i].fcstValue}` === '1') {
            fcstValue_sky = "맑음"
          }
          else if (`${dataApi[i].fcstValue}` === '3') {
            fcstValue_sky = "구름많음"
          }
          else if (`${dataApi[i].fcstValue}` === '4') {
            fcstValue_sky = "흐림"
          }
        }
        else if (dataApi[i].category === 'PTY' && dataApi[i].fcstDate === `${datavalue}`) {
          //var category_pty =(`계산 ${dataApi[i].category}`)
          var category_pty = "강수형태"
          var fcstValue_pty
          if (`${dataApi[i].fcstValue}` === '0') {
            fcstValue_pty = "비없음"
          }
          else if (`${dataApi[i].fcstValue}` === '1') {
            fcstValue_pty = "비"
          }
          else if (`${dataApi[i].fcstValue}` === '2') {
            fcstValue_pty = "비/눈"
          }
          else if (`${dataApi[i].fcstValue}` === '3') {
            fcstValue_pty = "눈"
          }
          else if (`${dataApi[i].fcstValue}` === '4') {
            fcstValue_pty = "소나기"
          }
        }
        else if (dataApi[i].category === 'POP' && dataApi[i].fcstDate === `${datavalue}`) {
          var category_pop = "강수확률"   //강수확률이름
          var fcstValue_pop = (`${dataApi[i].fcstValue}`) //강수활률값(%)
        }
        else if (dataApi[i].category === 'WAV' && dataApi[i].fcstDate === `${datavalue}`) {
        }
        else if (dataApi[i].category === 'PCP' && dataApi[i].fcstDate === `${datavalue}`) {
          var category_pcp = "1시간강수량"
          var fcstValue_pcp = (`${dataApi[i].fcstValue}`)
        }
        else if (dataApi[i].category === 'REH' && dataApi[i].fcstDate === `${datavalue}`) {
          var category_reh = "습도"
          var fcstValue_reh = (`${dataApi[i].fcstValue}`)
        }
        else if (dataApi[i].category === 'SNO' && dataApi[i].fcstDate === `${datavalue}`) {
        }

        if (dataApi[i].category === 'SNO' && dataApi[i].fcstDate === `${datavalue}`) {
          ii = ii + 1
          // await axios.post(`/Watch/Create?Id=${ii}
          //                             &BaseDate=${baseDate}&BaseTime=${baseTime}
          //                             &FcstDate=${fcstDate}&FcstTime=${fcstTime}
          //                             &Category_tmp=${category_tmp}&FcstValue_tmp=${fcstValue_tmp}
          //                             &Category_pop=${category_pop}&FcstValue_pop=${fcstValue_pop}
          //                             &Category_pty=${category_pty}&FcstValue_pty=${fcstValue_pty}
          //                             &Category_reh=${category_reh}&FcstValue_reh=${fcstValue_reh}
          //                             &Category_sky=${category_sky}&FcstValue_sky=${fcstValue_sky}
          // `) 

          const params = ({
            id: ii,
            BaseDate: baseDate,
            BaseTime: baseTime,
            FcstDate: fcstDate,
            FcstTime: fcstTime,
            Category_tmp: category_tmp,
            FcstValue_tmp: fcstValue_tmp,
            Category_pop: category_pop,
            FcstValue_pop: fcstValue_pop,
            Category_pcp: category_pcp,
            FcstValue_pcp: fcstValue_pcp,
            Category_pty: category_pty,
            FcstValue_pty: fcstValue_pty,
            Category_reh: category_reh,
            FcstValue_reh: fcstValue_reh,
            Category_sky: category_sky,
            FcstValue_sky: fcstValue_sky
          })

          apiwatch.push(params);
          setStateData(apiwatch)
        }
      }
    }

  }, [dataApi]);


  useEffect(() => {
    rowss();
  }, [rowss])


  // function isWatch(element) {
  //   if(element.FcstDate === '20230613')  {
  //     return true;
  //   }
  // }
  // const apple = statedata.find(isWatch);
  // console.log(apple)
  // console.log(statedata)
  //console.log(dataApi)

  const columns = (
    [
      { name: "id", header: "No", align: "center", width: 50, className: 'baseDateFont' },
      { name: "baseDate", header: "일자", align: "center", width: 90, className: 'baseDateFont', },
      { name: "baseTime", header: "시간", align: "center", width: 60, className: 'baseDateFont' },
      { name: "fcstDate", header: "일자", align: "center", width: 90, className: 'baseDateFont' },
      { name: "fcstDate1", header: "요일", align: "center", width: 70, className: 'baseDateFont' },
      { name: "fcstTime", header: "시간", align: "center", width: 80, className: 'baseDateFont' },
      { name: "fcstValue_pty", header: "날씨", align: "center", width: 100, className: 'baseDateFont' },
      { name: "fcstValue_pop", header: "비올확률", align: "center", width: 80, className: 'baseDateFont' },
      { name: "fcstValue_pcp", header: "강수량", align: "center", width: 80, className: 'baseDateFont' },
      { name: "fcstValue_sky", header: "하늘상태", align: "left", width: 140, className: 'baseDateFont' },
      { name: "fcstValue_tmp", header: "온도", align: "center", width: 85 },
      { name: "fcstValue_reh", header: "습도", align: "center", width: 85 },
      { name: "about", header: "녹발생내용", align: "center", width: 202 },
    ]
  );

  //<i class="fa-solid fa-moon"></i>
  const rows = statedata.map((row, i) => ({
    id: row.id,
    baseDate: row.id === 1 ? row.BaseDate : "",
    baseTime: row.id === 1 ? row.BaseTime : "",
    fcstDate: row.FcstDate,
    fcstDate1: dayjs(dayjs((row.FcstDate), "YYYYMMDD").toDate()).format("ddd") + "요일" === "토요일" ? `<b style="font-size:12px;color:#0277bd;">${dayjs(dayjs((row.FcstDate), "YYYYMMDD").toDate()).format("ddd") + "요일"}</b>`
      : dayjs(dayjs((row.FcstDate), "YYYYMMDD").toDate()).format("ddd") + "요일" === "일요일" ? `<b style="font-size:12px;color:#DB4455;">${dayjs(dayjs((row.FcstDate), "YYYYMMDD").toDate()).format("ddd") + "요일"}</b>`
        : `<b style="font-size:12px;color:black;">${dayjs(dayjs((row.FcstDate), "YYYYMMDD").toDate()).format("ddd") + "요일"} </b>`,
    fcstTime: dayjs(dayjs((row.FcstTime), "HHmm").toDate()).format("A hh") + "시",
    fcstValue_pty: row.FcstTime === "0600" ||
      row.FcstTime === "0700" ||
      row.FcstTime === "0800" ||
      row.FcstTime === "0900" ||
      row.FcstTime === "1000" ||
      row.FcstTime === "1100" ||
      row.FcstTime === "1200" ||
      row.FcstTime === "1300" ||
      row.FcstTime === "1400" ||
      row.FcstTime === "1500" ||
      row.FcstTime === "1600" ||
      row.FcstTime === "1700" ||
      row.FcstTime === "1800" ||
      row.FcstTime === "1900"
      ? row.FcstValue_pty === "비없음" ? `<img src=${nb01} style="width:28px; height:28px;" />${row.FcstValue_pty}`
        : row.FcstValue_pty === "비" ? `<img src=${nb08} style="width:28px; height:28px;" />${row.FcstValue_pty}`
          : row.FcstValue_pty === "비/눈" ? `<img src=${nb12} style="width:28px; height:28px;" />${row.FcstValue_pty}`
            : row.FcstValue_pty === "눈" ? `<img src=${nb11} style="width:28px; height:28px;" />${row.FcstValue_pty}`
              : row.FcstValue_pty === "소나기" ? `<img src=${nb07} style="width:28px; height:28px;" />${row.FcstValue_pty}`
                : null
      : row.FcstValue_pty === "비없음" ? `<img src=${nb01_n} style="width:28px; height:28px;" />${row.FcstValue_pty}`
        : row.FcstValue_pty === "비" ? `<img src=${nb08} style="width:28px; height:28px;" />${row.FcstValue_pty}`
          : row.FcstValue_pty === "비/눈" ? `<img src=${nb12} style="width:28px; height:28px;" />${row.FcstValue_pty}`
            : row.FcstValue_pty === "눈" ? `<img src=${nb11} style="width:28px; height:28px;" /> ${row.FcstValue_pty}`
              : row.FcstValue_pty === "소나기" ? `<img src=${nb07} style="width:28px; height:28px;" />${row.FcstValue_pty}`
                : null,

    fcstValue_pop: row.FcstValue_pop + `%`,
    fcstValue_pcp: row.FcstValue_pcp,
    //fcstValue_sky:row.FcstValue_sky,
    fcstValue_sky: row.FcstTime === "0600" ||
      row.FcstTime === "0700" ||
      row.FcstTime === "0800" ||
      row.FcstTime === "0900" ||
      row.FcstTime === "1000" ||
      row.FcstTime === "1100" ||
      row.FcstTime === "1200" ||
      row.FcstTime === "1300" ||
      row.FcstTime === "1400" ||
      row.FcstTime === "1500" ||
      row.FcstTime === "1600" ||
      row.FcstTime === "1700" ||
      row.FcstTime === "1800" ||
      row.FcstTime === "1900"
      ? row.FcstValue_sky === "맑음" ? `<img src=${nb01} style="width:28px; height:28px;" /> ${row.FcstValue_sky}<b style="color:#4caf50;font-weight:800; font-size:14px;">(낮)</b>`
        : row.FcstValue_sky === "구름많음" ? `<img src=${nb03} style="width:28px; height:28px;" /> ${row.FcstValue_sky}<b style="color:#4caf50;font-weight:800; font-size:14px;">(낮)</b>`
          : row.FcstValue_sky === "흐림" ? `<img src=${nb04} style="width:28px; height:28px;" /> ${row.FcstValue_sky}<b style="color:#4caf50;font-weight:800; font-size:14px;">(낮)</b>`
            : null
      : row.FcstValue_sky === "맑음" ? `<img src=${nb01_n} style="width:28px; height:28px;" /> ${row.FcstValue_sky}<b style="color:#ff6e40;font-weight:800; font-size:14px;">(밤)</b>`
        : row.FcstValue_sky === "구름많음" ? `<img src=${nb02_n} style="width:28px; height:28px;" /> ${row.FcstValue_sky}<b style="color:#ff6e40;font-weight:800; font-size:14px;">(밤)</b>`
          : row.FcstValue_sky === "흐림" ? `<img src=${nb04} style="width:28px; height:28px;" /> ${row.FcstValue_sky}<b style="color:#ff6e40;font-weight:800; font-size:14px;">(밤)</b>`
            : null,

    fcstValue_tmp: row.FcstValue_tmp <= 26 ? `<em style="font-size:16px;">${row.FcstValue_tmp}℃</em>`
      : row.FcstValue_tmp <= 30 ? `<em style="font-size:18px;color:darkgoldenrod">${row.FcstValue_tmp}℃</em>`
        : row.FcstValue_tmp <= 32 ? `<em style="font-size:18px;color:darkorange">${row.FcstValue_tmp}℃</em>`
          : row.FcstValue_tmp >= 33 ? `<em style="font-size:18px;color:red">${row.FcstValue_tmp}℃</em>`
            : null,
    fcstValue_reh: row.FcstValue_reh <= 55 ? `<em style="font-size:16px;">${row.FcstValue_reh}%</em>`
      : row.FcstValue_reh <= 70 ? `<em style="font-size:16px;color:darkorange">${row.FcstValue_reh}%</em>`
        : row.FcstValue_reh >= 71 ? `<em style="font-size:16px;color:red">${row.FcstValue_reh}%</em>`
          : null,
    about: (row.FcstValue_pty === "비" || row.FcstValue_pty === "소나기") && row.FcstValue_tmp >= "28" && row.FcstValue_reh >= "85"
      ? `<em style="font-size:15px;color:red">비/습도/온도 발청위험</em>`
      : row.FcstValue_tmp >= "27" && row.FcstValue_reh >= "80"
        ? `<em style="font-size:15px;color:#00796b">습도/온도 발청경계</em>`
        : row.FcstValue_tmp >= "26" && row.FcstValue_reh >= "70"
          ? `<em style="font-size:15px;color:#00796b">습도/온도 발청주의</em>`
          : row.FcstValue_tmp >= "-5" && row.FcstValue_reh <= "-3"
            ? `<em style="font-size:15px;color:red">배관 동파주의</em>`
            : row.FcstValue_tmp <= "-5"
              ? `<em style="font-size:15px;color:red">배관 동파위험</em>`
              : null,


  }));

  //혜더 복합칼럼설정
  const header = {
    height: 60,
    complexColumns: [
      {
        header: '기상청발표',
        name: '발표',
        childNames: ['baseDate', 'baseTime']
      },
      {
        header: '예보',
        name: '예보',
        childNames: ['fcstDate', 'fcstDate1', 'fcstTime']
      },
      {
        header: '비',
        name: '비',
        childNames: ['fcstValue_pop', 'fcstValue_pcp']
      },
    ]
  }


  //한글 및 테마설정--정적api 문서 확이해서 적용할것.
  const Gr = require('tui-grid');
  Gr.setLanguage('ko');
  Gr.applyTheme('striped', {
    // frozenBorder: {
    //   border: 'red',
    // },
    outline: {
      //border: 'blue',
      showVerticalBorder: true,
    },
    cell: {
      normal: {
        background: 'pink',
        border: '#DCDCDC',
        showVerticalBorder: true,
        showHorizontalBorder: true
      },

      header: {
        background: '#DCDCDC',
        border: '#C0C0C0',
        text: 'blue',
        showVerticalBorder: true,
        showHorizontalBorder: true
      },
      rowHeader: {
        background: '#DCDCDC',
        border: '#C0C0C0',
        text: 'blue',
        showVerticalBorder: true,
        showHorizontalBorder: true,
      },
      selectedRowHead: {
        background: '#e5f6ff',
        showVerticalBorder: true
      },
    },

    area: {
      header: {
        border: '#59b9ea',
        background: 'silver',
        showVerticalBorder: true,
        showHorizontalBorder: true,
      },
      body: {
        border: 'red',
        background: 'white',
        showVerticalBorder: true,
        showHorizontalBorder: true,
      },
    },
    //호버설정
    row: {
      hover: {
        background: 'silver'
      }
    },
  });

  //더블클릭시 중지 한번더블클릭하면 실행
  const handleDbClick = (ev) => {
    //ev.preventDefault();
    //console.log(ev.rowKey)
    timerstate ? setTimerstate(false) : setTimerstate(true)
    //console.log('더블클릭실행')
  };
  const handleMouseover = (ev) => {
    //ev.preventDefault();
    //console.log(ev.rowKey)
    setTimerstate(false)
  };

  //랜더링중지 싱행
  const stopHandle = () => {
    timerstate ? setTimerstate(false) : setTimerstate(true)
  };


  return (
    <div >
      <Container maxWidth="lg" style={{ marginBottom: '4px' }}>
        <div className='yeboh3'><img src={nb01} style={{ width: '40px', height: '40px', marginTop: '-6px' }} alt='' />단기날씨예보<img src={nb08} style={{ width: '40px', height: '40px' }} alt='' /></div>
        <div style={{ textAlign: 'right' }}>
          <label>예보시간:{watchTimersub}</label>
          {timerstate ?
            <Button
              type="button"
              variant="contained"
              onClick={stopHandle}
              style={{
                background: '#0277bd',
                color: 'white',
                height: 30,
                width: 130,
                marginRight: 3,
                float: "center",
              }}
            >
              <i className="fa-solid fa-hand" style={{ fontSize: '16px' }}></i>
              잠시중지
            </Button>
            : <Button
              type="button"
              variant="contained"
              onClick={stopHandle}
              style={{
                background: 'red',
                color: 'white',
                height: 30,
                width: 130,
                marginRight: 3,
                float: "center",
              }}
            >
              <i className="fa-solid fa-hand" style={{ fontSize: '16px' }}></i>
              다시실행
            </Button>}
          <Button
            id="homemove"
            variant="contained"
            startIcon={<HomeIcon />}
            style={{
              background: '#004d40',
              color: 'white',
              height: 30,
              width: 120,
              float: "center",
            }}
            onClick={() => {
              history.push('/');
            }}
          >
            홈이동
          </Button>
        </div>
      </Container>
      <Container maxWidth="lg">
        <Box style={{ border: "1px solid", borderColor: "#42a5f5", borderRadius: "1px" }}>
          <Grid
            columns={columns}
            data={rows}
            header={header}
            scrollY={true}
            scrollX={true}
            //rowHeight의 높이를 고정하면서 기본 행 높이보다 작은 값으로 설정하려는 경우에는 다음과 같이 minRowHeight 옵션을 사용하면 된다. 단, rowHeight의 최소값은 9이다.
            rowHeight={'auto'}
            // rowHeight= {20}
            minRowHeight={40}
            bodyHeight={210}
            //bodyHeight={"auto"}
            heightResizable={true}
            virtualScrolling={false}
            // pageOptions={{ useClient: true, perPage: 500 }} // front에서만 페이징 하는 속성
            usageStatistics={false} //전 세계적으로 TOAST UI Grid가 얼마나 널리 사용되고 있는지 파악 사용
            ref={gridRef}
            onDblclick={handleDbClick}
            onMouseover={handleMouseover}
          />
          <WatchChart statedata={statedata} />
          <div style={{ paddingTop: '0px', marginLeft: '10px', color: 'red', fontSize: '15px' }}>-피막녹 발생원인-</div>
          <ol style={{ marginLeft: '10px', color: 'blue', fontSize: '12px' }}>
            <li>염화물 [황산, 염산, 아초산, 초산, 소금[손의땀] 등]</li>
            <li>오염 [먼지,물]</li>
            <li>환경요인 [대기중의 온도[28이상], 습도[60%이상]과 철표면과 대기온도차가 3.7도 이상이면 녹발청이 2배 증가됨]</li>
            <li>여름철에 절대 에어컨에서 보관하면 안됨 {'🔴'}예시:냉장고 콜라</li>
            <em style={{ marginLeft: '20px', marginRight: '20px', float: 'right' }}>{`기상발표시간:${watchTimersub}`}</em>
            {timerstate ? <em style={{ marginLeft: '20px', marginRight: '10px', float: 'right' }}>현재시간:<WatchTimer /></em> : <em style={{ marginLeft: '20px', marginRight: '10px', float: 'right', color: 'red' }}>잠시중지</em>}
            <br />
          </ol>
        </Box>
      </Container>
    </div>
  )
}

export default WatchYebo